import { differenceInYears, isExists } from 'date-fns';
import { validate as validateEmail } from 'email-validator'
import { HolderModel } from '../models/holder.model';
import { PartnerFormModel } from '../models/partner.model';

const MIN_AGE = 18;

const validateString = (str?: string): boolean => (str || '').trim().length < 1;
// assuming if not USA, then Canada format
const validateZip = (zip: string, country?: string): boolean => country === 'USA' ? !/^\d{5}$/.test(zip) : !/^\w\d\w \d\w\d$/.test(zip);
// if phone is not required only validate if not empty
const validatePhone = (phone?: string, required: boolean = true): boolean => !((!required && !phone) || (/\d{10}/.test(phone || '')));
const validateArray = (arr: Array<string>): boolean => arr.length < 1;

export const validateHolder = (holder: HolderModel) => {
  const {
    firstName,
    lastName,
    address1,
    city,
    state,
    zipCode,
    country,
    phoneNumberPrimary,
    phoneNumberSecondary,
    dateOfBirth,
    learnMore,
  } = holder;

  let [year, month, day] = dateOfBirth.map(val => Number.parseInt(val));
  month = month - 1;
  const hasDateOfBirthError = !dateOfBirth.every(Boolean) || !isExists(year, month, day) || differenceInYears(Date.now(), new Date(year, month, day)) < MIN_AGE

  return {
    firstName: validateString(firstName),
    lastName: validateString(lastName),
    address1: validateString(address1),
    city: validateString(city),
    state: !state,
    zipCode: validateZip(zipCode, country),
    phoneNumberPrimary: validatePhone(phoneNumberPrimary),
    phoneNumberSecondary: validatePhone(phoneNumberSecondary, false),
    dateOfBirth: hasDateOfBirthError ,
    learnMore: validateArray(learnMore),
  };
};

export const validatePartnerEmail = (email: string, holder: HolderModel) => {
  return {
    email: !validateEmail(email),
    emailSame: (holder.email || '').toLowerCase() === email.toLowerCase(),
  }
}

export const validatePartner = (partner: PartnerFormModel, holder: HolderModel) => {
  const {
    firstName,
    lastName,
    address1,
    city,
    country,
    state,
    zipCode,
    email,
    phoneNumber,
    partnerType,
  } = partner;

  return {
    firstName: validateString(firstName),
    lastName: validateString(lastName),
    address1: validateString(address1),
    city: validateString(city),
    state: validateString(state),
    zipCode: validateZip(zipCode || '', country),
    ...validatePartnerEmail(email, holder),
    phoneNumber: validatePhone(phoneNumber),
    partnerType: validateString(partnerType),
  };
}
